import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';
import { InfoDialog } from 'components';
import { Box, IconButton, useTheme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    button: {},
    circle: {
        borderColor: theme.palette.grey['400'],
        color: theme.palette.grey['300'],

        '&:hover': {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
        },
    },
}));

const InfoButton = props => {
    const {
        title = texts.DIALOG_TITLE,
        content,
        menuOpenInfoDialog = false,
        setMenuOpenInfoDialog,
        disableMarginBottom,
        sx,
        ...rest
    } = props;
    const ownClasses = useStyles();
    const theme = useTheme();
    const [infoOpen, setInfoOpen] = useState(false);

    useEffect(() => {
        setInfoOpen(menuOpenInfoDialog);
    }, [menuOpenInfoDialog]);

    const closeInfoDialog = () => {
        setMenuOpenInfoDialog && setMenuOpenInfoDialog(false);
        setInfoOpen(false);
    };

    return (
        <React.Fragment>
            <IconButton
                disableRipple
                size="small"
                onClick={() => setInfoOpen(true)}
                sx={theme => ({
                    marginBottom: disableMarginBottom ? 0 : 2,
                    marginLeft: theme.spacing(2),
                    ...(typeof sx === 'function' ? sx(theme) : sx),
                    '&:hover, &:focused': {
                        background: 'inherit',
                    },
                })}
                {...rest}
            >
                <Box
                    component="span"
                    width="30px"
                    height="30px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="20px"
                    bgcolor={theme.palette.common.white}
                    border="1px solid"
                    className={ownClasses.circle}
                >
                    ?
                </Box>
            </IconButton>
            <InfoDialog
                handleClose={closeInfoDialog}
                open={infoOpen}
                title={title}
                message={content}
            />
        </React.Fragment>
    );
};

InfoButton.propTypes = {
    title: PropTypes.string,
    content: PropTypes.node.isRequired,
    menuOpenInfoDialog: PropTypes.bool,
    disableMarginBottom: PropTypes.bool,
    setMenuOpenInfoDialog: PropTypes.func,
};

export default InfoButton;
